import { getFilter } from '../../pages/my-learning/components/date-filter/util'
import name from './name'
import { createSlice } from '@reduxjs/toolkit'

const DEFAULT_PAGINATION = {
  page: 0,
  limit: 10
}

const DEFAULT_VISIBILE_LIMIT = 5

const initialState = {
  fromPath: null,
  filters: {
    ...getFilter('This Month'),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    present: 'This Month'
  },
  learningOverview: {
    loading: true,
    data: null
  },
  inprogressSkillBites: {
    limit: DEFAULT_VISIBILE_LIMIT,
    loading: true,
    data: {
      items: [],
      meta: null
    }
  },
  completedSkillBites: {
    limit: DEFAULT_VISIBILE_LIMIT,
    loading: true,
    data: {
      items: [],
      meta: null
    }
  },
  inprogressPlaylists: {
    limit: DEFAULT_VISIBILE_LIMIT,
    loading: true,
    data: {
      items: [],
      meta: null
    }
  },
  completedPlaylists: {
    limit: DEFAULT_VISIBILE_LIMIT,
    loading: true,
    data: {
      items: [],
      meta: null
    }
  },
  learningHistory: {
    loading: true,
    data: null
  },
  learningHistoryFilters: {
    ...getFilter('This Month'),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    ...DEFAULT_PAGINATION,
    present: 'This Month'
  }
}

const insights = createSlice({
  name,
  initialState,
  reducers: {
    reset: (state) => {
      const preserve = ['filters', 'learningHistoryFilters']

      const preservedState = preserve.reduce((acc, value) => {
        acc[value] = state[value]
        return acc
      }, {})

      return {
        ...initialState,
        ...preservedState
      }
    },
    setLearningOverview (state, action) {
      state.learningOverview = {
        data: action.payload,
        loading: false
      }
    },
    setLearningOverviewLoading (state, action) {
      state.learningOverview.loading = action.payload
    },
    setFromPath (state, action) {
      state.fromPath = action.payload
    },
    setLearningHistory (state, action) {
      state.learningHistory = {
        data: action.payload,
        loading: false
      }
    },
    setLearningHistoryLoading (state, action) {
      state.learningHistory.loading = action.payload
    },
    setInprogressSkillBites (state, action) {
      state.inprogressSkillBites = {
        ...state.inprogressSkillBites,
        data: {
          items: [...state.inprogressSkillBites.data.items, ...action.payload.items],
          meta: action.payload.meta
        },
        loading: false
      }
    },
    setInprogressSkillBitesLoading (state, action) {
      state.inprogressSkillBites.loading = action.payload
    },
    setInprogressSkillBitesLimit (state) {
      state.inprogressSkillBites.limit += DEFAULT_VISIBILE_LIMIT
    },
    setCompletedSkillBites (state, action) {
      state.completedSkillBites = {
        ...state.completedSkillBites,
        data: {
          items: [...state.completedSkillBites.data.items, ...action.payload.items],
          meta: action.payload.meta
        },
        loading: false
      }
    },
    setCompletedSkillBitesLoading (state, action) {
      state.completedSkillBites.loading = action.payload
    },
    setCompletedSkillBitesLimit (state) {
      state.completedSkillBites.limit += DEFAULT_VISIBILE_LIMIT
    },
    setInprogressPlaylists (state, action) {
      state.inprogressPlaylists = {
        ...state.inprogressPlaylists,
        data: {
          items: [...state.inprogressPlaylists.data.items, ...action.payload.items],
          meta: action.payload.meta
        },
        loading: false
      }
    },
    setInprogressPlaylistLoading (state, action) {
      state.inprogressPlaylists.loading = action.payload
    },
    setInprogressPlaylistLimit (state) {
      state.inprogressPlaylists.limit += DEFAULT_VISIBILE_LIMIT
    },
    setCompletedPlaylists (state, action) {
      state.completedPlaylists = {
        ...state.completedSkillBites,
        data: {
          items: [...state.completedPlaylists.data.items, ...action.payload.items],
          meta: action.payload.meta
        },
        loading: false
      }
    },
    setCompletedPlaylistsLoading (state, action) {
      state.completedPlaylists.loading = action.payload
    },
    setCompletedPlaylistsLimit (state) {
      state.completedPlaylists.limit += DEFAULT_VISIBILE_LIMIT
    },
    setFilters: (state, { payload }) => {
      state.learningOverview.data = null
      state.filters = {
        ...state.filters,
        ...payload
      }
    },
    setLearningHistoryFilters: (state, { payload }) => {
      const payloadHasTimeFilter = payload.startDate || payload.endDate
      if (payloadHasTimeFilter) {
        state.learningHistory.data = null
      }

      state.learningHistoryFilters = {
        ...state.learningHistoryFilters,
        ...(payloadHasTimeFilter && DEFAULT_PAGINATION),
        ...payload
      }
    }
  }
})

export const {
  reset,
  setFromPath,
  setLearningHistoryFilters,
  setLearningOverview,
  setLearningOverviewLoading,
  setLearningHistory,
  setLearningHistoryLoading,
  setCompletedSkillBites,
  setCompletedSkillBitesLoading,
  setCompletedSkillBitesLimit,
  setInprogressSkillBites,
  setInprogressSkillBitesLoading,
  setInprogressSkillBitesLimit,
  setCompletedPlaylists,
  setCompletedPlaylistsLoading,
  setCompletedPlaylistsLimit,
  setInprogressPlaylists,
  setInprogressPlaylistLoading,
  setInprogressPlaylistLimit,
  setFilters
} = insights.actions

export default insights.reducer
